module.exports = __webpack_public_path__ + "static/media/light-r-8.7091bd16.png";